// 過去入力検索で運用可能かを確認中のため、頻出作業選択は一時的に非表示とする。
// 再表示する場合はこのフラグだけを true に戻す。
export const ESTIMATE_FREQUENT_WORKS_ENABLED = false;

export const ESTIMATE_FREQUENT_WORKS = Object.freeze([
  Object.freeze({
    id: 'daily-cleaning',
    item_nm: '日常清掃',
    english_item_nm: 'Daily cleaning',
    quantity: 12,
    unit_nm: '月',
    english_unit_nm: 'month',
    work_frequency: '毎月',
    english_work_frequency: 'Monthly',
    annual_count: 12,
    service_count: 1
  }),
  Object.freeze({
    id: 'water-tank-cleaning',
    item_nm: '貯水槽清掃',
    english_item_nm: 'Water tank cleaning',
    quantity: 2,
    unit_nm: '回',
    english_unit_nm: 'times',
    work_frequency: '年2回',
    english_work_frequency: 'Twice a year',
    annual_count: 2,
    service_count: 1
  }),
  Object.freeze({
    id: 'fire-inspection',
    item_nm: '消防点検',
    english_item_nm: 'Fire equipment inspection',
    quantity: 2,
    unit_nm: '回',
    english_unit_nm: 'times',
    work_frequency: '年2回',
    english_work_frequency: 'Twice a year',
    annual_count: 2,
    service_count: 1
  })
]);

export const frequentWorkLineAttributes = (work, languageType = 'japanese') => ({
  line_type: 'detail',
  item_nm: languageType === 'english' ? work.english_item_nm : work.item_nm,
  quantity: work.quantity,
  quantity_decimal_places: 0,
  unit_nm: languageType === 'english' ? work.english_unit_nm : work.unit_nm,
  work_frequency: languageType === 'english'
    ? work.english_work_frequency
    : work.work_frequency,
  annual_count: work.annual_count,
  service_count: work.service_count
});
